import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Row } from 'antd';

interface FilterWebsiteProps {
    websites: string[];
    onChange: (id: string, value: string[]) => void;
}


const auctionSites = ['Bring a Trailer', 'Cars and Bids', 'MB Market', 'PCar']

export const FilterWebsite: React.FC<FilterWebsiteProps> = ({ websites, onChange }) => {
    const [checkedValues, setCheckedValues] = useState<string[]>(websites || []);

    

    useEffect(() => {
        setCheckedValues(websites || []);
    }, [websites]);

    const handleChange = (checkedValues: string[]) => {
        setCheckedValues(checkedValues);
        onChange('websites', checkedValues);
    };

    return (
        <Checkbox.Group style={{ width: '100%' }} value={checkedValues} onChange={handleChange}>
            <Col>
                {auctionSites.map((site) => (
                    <Row key={site} style={{ marginBottom: '10px' }}>
                        <Checkbox value={site}>{site}</Checkbox>
                    </Row>
                ))}
            </Col>
        </Checkbox.Group>
    );
};

export default FilterWebsite;